import { ConditionValue, OperationEnum, OperationHandler, OperationsMapper } from '../types';
import { StringOperationsMapper } from '../string';
import { NumericOperationsMapper } from '../numeric';
import { DateOperationsMapper } from '../date';
import { BooleanOperationsMapper } from '../boolean';

const operationEnrichersMapper: OperationsMapper = {
  ...StringOperationsMapper,
  ...NumericOperationsMapper,
  ...DateOperationsMapper,
  ...BooleanOperationsMapper,
};

export function useOperation(operation: OperationEnum, value: ConditionValue): OperationHandler | undefined {
  const operationContextEnricher = operationEnrichersMapper[operation];

  return operationContextEnricher ? operationContextEnricher(value) : undefined;
}
